export const SUBSCRIPTION_TYPES = {
  ACTIVE: 'ACTIVE'
};
